import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { lazyImport } from '@helpers'
import {
  withApollo,
  withErrorBoundary,
  withExchangeRates,
  withI18next,
  withSkeletonTheme,
  withStaffPickImage,
  withSuspense,
  withTheme,
} from '@hocs'
import { $settings } from '@velasca/utils/globals'

const { RecentProductsSlider } = lazyImport(
  () => import('@components/RecentProductsSlider/RecentProductsSlider'),
  'RecentProductsSlider',
)

const recentProductsSliderLiquidCollectionEl = document.getElementById(
  'recent-products-slider-liquid-collection',
)

const RecentProductsLiquidCollectionApp = () => <RecentProductsSlider />

const RecentProductsLiquidCollectionAppWrapper = pipe(
  RecentProductsLiquidCollectionApp,
  withSuspense,
  withStaffPickImage,
  withExchangeRates,
  withSkeletonTheme,
  withI18next,
  withApollo,
  withErrorBoundary,
  withTheme,
)

export const renderRecentProductsLiquidCollectionApp = () => {
  if (
    recentProductsSliderLiquidCollectionEl &&
    $settings.recentProductsCollectionEnabled
  ) {
    ReactDOM.createRoot(recentProductsSliderLiquidCollectionEl).render(
      <RecentProductsLiquidCollectionAppWrapper />,
    )
  }
}
